<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        title="KEEP IN TOUCH WITH US"
        pace="6"
      >
        Are you in doubt? Is your vehicle vibrating, shaking or making an unknown noise?
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: 'BaseBusinessInfo',

  props: { dark: Boolean },
};
</script>
